<mojo-mci-preview-mode-dialog [displayDialog]="showDialog" (onOk)="okHandler($event)" (onCancel)="cancelHandler()"
    [clients]="(clients$ | async)" [clientParents]="(clientParents$ | async)" [dialogTitle]="'Preview'">
</mojo-mci-preview-mode-dialog>
